<template>
  <div class="datepicker-header">
    <div
      class="date-button previous"
      @click="updateYear(calender.years - 1)"
    >
      <p4a-icon
        class="year"
        :icon="'year'"
      >
      </p4a-icon>
    </div>
    <div
      class="date-button previous"
      @click="updateMonth(calender.months - 1)"
    >
      <p4a-icon
        class="month"
        :icon="'month'"
      >
      </p4a-icon>
    </div>
    <label
      class="month-year-label"
      v-text="displayText"
    >
    </label>
    <div
      class="date-button next"
      @click="updateMonth(calender.months + 1)"
    >
      <p4a-icon
        class="month"
        :icon="'month'"
      />
    </div>
    <div
      class="date-button next"
      @click="updateYear(calender.years + 1)"
    >
      <p4a-icon
        class="year"
        :icon="'year'"
      />
    </div>
  </div>
</template>

<script>
  import MomentJS from 'moment'

  import Locales from '../../../localization/Locales'

  export default {
    name: 'DatepickerHeader',
    components: {
    },

    i18n: {
      messages: Locales
    },

    data () {
      return {
      }
    },
    props: {
      calender: {
        default: function () {
          return {}
        },
        type: Object
      }
    },
    computed: {
      displayText () {
        let self = this
        let monthYear = MomentJS(self.calender)
        let result = self.$t('months.' + monthYear.format('MMMM').toLowerCase()) + ' ' + monthYear.format('YYYY')

        return result
      }
    },
    methods: {
      updateMonth (newMonth) {
        this.$emit('updateMonth', newMonth)
      },
      updateYear (newYear) {
        this.$emit('updateYear', newYear)
      }
    },
    watch: {
      calender: {
        handler: function () {
        },
        immediate: true,
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../uikit';

  .datepicker-header {
    box-sizing: border-box;
    display: block;
    height: 50px;
    padding: 12.5px 12.5px 11.5px 12.5px;
    border-bottom: 1px solid $primaryBorderColor;

    .date-button {
      box-sizing: border-box;
      display: inline-block;
      vertical-align: top;
      height: 25px;
      margin: 0 5px 0 5px;
      cursor: pointer;

      &.previous {
        -moz-transform: scaleX(-1);
        -o-transform: scaleX(-1);
        -webkit-transform: scaleX(-1);
        transform: scaleX(-1);
      }

      svg {
        fill: $iconSvgColor;
        height: 25px;

        &:hover {
          fill: $iconSvgColorHover;
        }
        &.year {
          width: 11px;
        }
        &.month {
          width: 6px;
        }
      }
    }

    .month-year-label {
      box-sizing: border-box;
      display: inline-block;
      text-align: center;
      cursor: default;
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;

      color: #58585b;
      line-height: 25px;
      font-size: 17px;
      font-weight: 300;

      width: calc(100% - 90px);
      max-width: calc(100% - 90px);
      margin: 0 auto;

      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/datepicker/DatepickerHeader.vue